import { Injectable } from '@angular/core';
import { InvoiceUploadHttpService } from '@invoice-upload/services/invoice-upload-http.service';
import { Observable } from 'rxjs';
import { InvoiceUpload } from '@invoice-upload/models/invoice-upload';
import { select, Store } from '@ngrx/store';
import { ApplicationState } from '../../store/application-store';
import * as invoiceUploadActions from '@invoice-upload/actions/invoice-upload.actions';
import * as invoiceUploadSelectors from '@invoice-upload/selectors/invoice-upload';
import { DocumentType } from '@invoice-upload/models/document-type-code';
import { SaveInvoiceUploadWidgetConfigurationRequest, InvoiceUploadWidgetConfigurationModel } from
  '@invoice-upload/models/save-invoice-upload-widget-configuration-request';
import {GroupedNameValuePairs, NameValueDto} from "@common/models/name-value";

@Injectable({
  providedIn: 'root'
})
export class InvoiceDocumentService {

  constructor(
    private readonly invoiceUploadHttpService: InvoiceUploadHttpService,
    private readonly store: Store<ApplicationState>,
  ) {
  }

  getInvoiceDocument(invoiceId: string): Observable<Blob> {
    return this.invoiceUploadHttpService.getInvoiceDocument(invoiceId);
  }

  loadInvoices(widgetConfigurationId: number) {
    this.store.dispatch(invoiceUploadActions.load({ widgetConfigurationId }));
  }

  getInvoices(widgetConfigurationId: number): Observable<InvoiceUpload[]> {
    return this.store.pipe(select(invoiceUploadSelectors.getInvoices(widgetConfigurationId)));
  }

  uploadInvoicePdfs(files: any[], widgetConfigurationId: number): Observable<any> {
    return this.invoiceUploadHttpService.uploadInvoice(files, widgetConfigurationId);
  }

  deleteInvoice(id: string): Observable<any> {
    return this.invoiceUploadHttpService.deleteInvoice(id);
  }

  getDocumentTypes(): Observable<DocumentType[]> {
    return this.invoiceUploadHttpService.getDocumentTypes();
  }

  createCopyOfInvoiceUploadConfiguration(saveRequest: SaveInvoiceUploadWidgetConfigurationRequest): Observable<boolean> {
    return this.invoiceUploadHttpService.createCopyOfInvoiceUploadConfiguration(saveRequest);
  }

  saveInvoiceUploadConfiguration(saveRequest: SaveInvoiceUploadWidgetConfigurationRequest): Observable<boolean> {
    return this.invoiceUploadHttpService.saveInvoiceUploadConfiguration(saveRequest);
  }

  getInvoiceUploadConfiguration(widgetConfigId: number): Observable<InvoiceUploadWidgetConfigurationModel> {
    return this.invoiceUploadHttpService.getInvoiceUploadConfiguration(widgetConfigId);
  }

  getPurchaseOrdersAndContractsForSupplierCreditor(supplierCreditorUri: number): Observable<GroupedNameValuePairs[]> {
    return this.invoiceUploadHttpService.getPurchaseOrdersAndContractsForSupplierCreditor(supplierCreditorUri)
  }
}
